import { useState } from "react";
import { PopularServicesType } from "../types/server";
import { requestHelper } from "../helpers/request-helper";
import { formatAndRaiseError } from "../helpers/general";

export function usePopularServices() {
  let [data, setData] = useState<PopularServicesType>();
  let [loading, setLoading] = useState(false);
  let [error, setError] = useState(null);

  function retrive() {
    setLoading(true);
    setError(null);
    return requestHelper(
      `
          query listPopularServices {
            listPopularServices {
              id
              alias
              name
              display_name
              description
              unit
              pricing {
                id
                price
                variation {
                  id
                  alias
                  name
                }
              }
              children {
                id
                name
                alias
                display_name
                description
                unit
                pricing {
                  price
                  id
                  variation {
                    id
                    alias
                    name
                  }
                }
              }
            }
          }
        `
    )
      .then((data) => {
        setData({ data });
      })
      .catch(formatAndRaiseError)
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return { retrive, data, loading, error };
}
